module.exports = __webpack_public_path__ + "static/media/how_ja.b8eadd87.vtt";